var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTestmanager(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5625 0H5.0625V1.25H0.125V17.875H5.34375V15.875H2.125V3.25H5.0625V4.5H9.5625V3.25H12.5V4.78125H14.5V1.25H9.5625V0ZM6.875 5.75H17.875V17.875H6.875V5.75ZM8.875 7.75V15.875H15.875V7.75H8.875ZM10.125 9H14.625V11.25H10.125V9ZM12.375 12.375H10.125V14.625H12.375V12.375Z",
    className: "iconFill"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestmanager);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik05LjU2MjUgMEg1LjA2MjVWMS4yNUgwLjEyNVYxNy44NzVINS4zNDM3NVYxNS44NzVIMi4xMjVWMy4yNUg1LjA2MjVWNC41SDkuNTYyNVYzLjI1SDEyLjVWNC43ODEyNUgxNC41VjEuMjVIOS41NjI1VjBaTTYuODc1IDUuNzVIMTcuODc1VjE3Ljg3NUg2Ljg3NVY1Ljc1Wk04Ljg3NSA3Ljc1VjE1Ljg3NUgxNS44NzVWNy43NUg4Ljg3NVpNMTAuMTI1IDlIMTQuNjI1VjExLjI1SDEwLjEyNVY5Wk0xMi4zNzUgMTIuMzc1SDEwLjEyNVYxNC42MjVIMTIuMzc1VjEyLjM3NVoiIGNsYXNzPSJpY29uRmlsbCIvPgo8L3N2Zz4K";
export { ForwardRef as ReactComponent };